<template>
  <div></div>
</template>

<script>


export default {
  name: 'VideoComp',
  type: 'component',

  props: ['x', 'y', 'src', 'scale'],

  beforeDestroy() {

    this.$texture.baseTexture.source.pause()
    if(this.$tween) this.$tween.kill()
  },

  mounted() {

    this.addFlame()
  },

  methods: {

    play() {
      
      this.$texture.baseTexture.source.play()
    },

    addFlame() {

      this.$texture = PIXI.Texture.fromVideo(require('@/assets/video/'+ this.src +'.webm'))

      let sprite = new PIXI.Sprite(this.$texture)
          sprite.anchor.set(0.5, 0.5)
          sprite.position.set(this.x, this.y)
          sprite.scale.set(this.scale, this.scale)

          if(this.src != 'coeur') {

            sprite.blendMode = PIXI.BLEND_MODES.ADD
            sprite.alpha = 0

            this.$parent.$foreground.addChild(sprite)
            this.$parent.$sprites_foreground.push(sprite)
            this.$tween = TweenMax.to(sprite, 0.5, { alpha: 1, ease : Linear.easeNone, delay: _.random(2,4) })

          } else {

            this.$texture.baseTexture.autoPlay = false
            this.$texture.baseTexture.source.loop = false
            this.$parent.addMask(sprite)
            this.$parent.$container_ruban.addChild(sprite)
            this.$parent.$sprites_foreground.push(sprite)
          }
    },
  }

}

</script>
